import { whatWeDoAPI } from './what-we-do.js';
import { igniteAPI } from './ignite';
import { newsAPI } from './news';

export const initAPI = () => {
    whatWeDoAPI.init();
    igniteAPI.init();
    newsAPI.init();
}